<app-header />

<main class="main">
  <router-outlet />
</main>
